import Accordion, {AccordionProps} from '@mui/material/Accordion';
import AccordionSummary, {accordionSummaryClasses} from '@mui/material/AccordionSummary';
import {styled} from '@mui/material/styles';

export const AccordionStyled = styled(Accordion)<AccordionProps>(() => ({
	boxShadow: 'none',
	'&.Mui-expanded': {
		margin: '0 0 16px 0',
	},
	'&.Mui-expanded::before': {
		opacity: 1,
	},
}));

export const AccordionSummaryStyled = styled(AccordionSummary)(({theme}) => ({
	[`& .${accordionSummaryClasses.expandIconWrapper}`]: {
		color: theme.palette.primary.main,
	},
}));
